module.exports = __webpack_public_path__ + "toGroom-we-y-g.bf214469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-y-g.jpg
// module id = 7n4m
// module chunks = 0